import React from 'react'
import Grid from '../../components/grid/Grid'
import Navbar from '../../components/navbar/Navbar'

function MainPage() {
  return (
    <>
        <Grid/>
        <Navbar />
    </>
  )
}

export default MainPage